<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vs-table id="orderLogsTable" :max-items="itemsPerPage" :data="orderLogs">
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex"  class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                <vx-tooltip text="Excel Export" position="top">
                  <vs-button @click="getExcel" class="panel-action text-dark xlarge-button panel-action-box-shadow"
                             color="transparent" icon-pack="feather" icon="icon-download">
                  </vs-button>
                </vx-tooltip>
              </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <feather-icon
                          v-if="chip.value === true"
                          icon="CheckIcon"
                          svgClasses="w-4 h-4 text-primary"
                        />
                        <feather-icon
                          v-else-if="chip.value === false"
                          icon="XIcon"
                        />
                        <span
                          v-else
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-2/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'id' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('id')"
            >Id
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('created')"
            >Tarih
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('created')"
            >Saat
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12 px-1">
          <vs-button class="p-1 weight-600" color="primary" type="flat">
            Şube
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'totalPrice' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('totalPrice')"
            >Tutar
          </vs-button>
        </vs-th>
        <vs-th class="w-3/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'createdUser' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('createdUser')"
            >Personel
          </vs-button>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="w-2/12 text-center">
            {{ tr.id }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.date }}
          </vs-td>
          <vs-td class="w-1/12 text-center">
            {{ tr.time }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.branchName }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ $toCurrency(tr.totalPrice) }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.userName }}
          </vs-td>
          <template class="expand-user" slot="expand">
            <div class="con-expand-users w-full">
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" vs-w="3" vs-offset="1.2">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-row
                      class="entryDetailRow"
                      vs-type="flex"
                      vs-w="12"
                      v-for="entry in tr.cartEntries"
                      :key="entry.id"
                      vs-justify="center"
                    >
                      {{ entry.productName }}
                      {{ entry.quantity > 1 ? "x" + entry.quantity : null }}
                      <p
                        class="w-full text-center"
                        v-for="extra in entry.extras"
                        :key="extra.id"
                        vs-justify="center"
                      >
                        x{{ extra.quantity }} - {{ extra.name }}
                      </p>
                    </vs-row>
                  </vs-row>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4" vs-offset="0.3">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-row
                      class="entryDetailPayment"
                      vs-type="flex"
                      vs-w="12"
                      v-for="payment in tr.paymentInformations"
                      :key="payment.id"
                    >
                      <vx-tooltip
                        :text="payment.description"
                        type="gradient"
                        :color="
                          payment.description != null
                            ? 'primary'
                            : 'transparent'
                        "
                      >
                        <span>
                          {{ payment.paymentMethod.name }} :
                          {{
                            payment.value
                              ? payment.value + payment.unit
                              : $toCurrency(payment.price)
                          }}
                          <template v-if="payment.financialDocument != null">
                              (Pavo Sipariş No: {{ payment.financialDocument.orderNo }})
                              
                          </template>
                        </span>
                        <span v-if="payment.financialDocument != null && $isAdmin()">
                                  <a style="text-decoration: underline;" target="_blank" :href="'https://pavopay.pavo.com.tr/InquiryOperations/SaleInquiryView/Index?q=' + payment.financialDocument.saleUid.replace(/-/g, '')">E-Arşiv</a>
                              </span>
                      </vx-tooltip>
                    </vs-row>
                  </vs-row>
                </vs-col>
              </vs-row>
            </div>
          </template>
        </vs-tr>
      </template>
    </vs-table>
    <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" vs-align="center">
      <span class="text-dark text-smaller weight-500"> Toplam Tutar : </span>
      <span class="text-primary text-small bold mr-1 ml-3">
        {{ getTotalAmount }} ₺ / {{ totalPriceWithoutPaging }} ₺
      </span>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12">
      <pagination-default
        :setCurrentPage="tableOptions.pageIndex"
        :totalLenght="calculatePageLength"
        @currentPage="getCurrentPage"
      ></pagination-default>
    </vs-row>
  </div>
</template>

<script>
import PaginationDefault from "../../PaginationDefault";
import { getOrderLogs,getOrderLogsForDealer,getOrderLogsExcel,getOrderLogsExcelForDealer } from "@/api/Cart";
import GlobalFilter from "../../GlobalFilter";

export default {
  data() {
    return {
      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,
      totalDataRow: 0,
      orderLogs: [],
      isFilterActive: false,
      filterOptions: [
        "dateRange",
        "timeRange",
        "branch",
        "product",
        "extra",
        "personal",
        "paymentMethod",
        "price",
        "isNavigatedByQuestion",
      ],
      filterOptionNames: [
        "Tarih",
        "Saat",
        "Şube",
        "Ürün",
        "Ekstra",
        "Personel",
        "Ödeme",
        "Tutar",
        "Pasta Sorusu",
      ],
      isFiltererOpen: false,
      filterChips: [],
      totalPriceWithoutPaging:0
    };
  },
  components: {
    PaginationDefault,
    GlobalFilter,
  },
  computed: {
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
    getTotalAmount() {
      return this.orderLogs.reduce(function (total, num) {
        return total + num.totalPrice;
      }, 0);
    },
  },
  methods: {
    getExcel() {
      if (this.$isRegionalCenterBranch()) {
        getOrderLogsExcelForDealer(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Sıcak Satış' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
      }else{
        getOrderLogsExcel(this.tableOptions).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Sıcak Satış Raporu' + now.getDate() + " " + this.$months()[now.getMonth()]
            .name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })}
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        dateRange: {
          startDate:
            this.$now().getHours() >= 0 && this.$now().getHours() <= 2
              ? this.$preDate()
              : this.$now.date(),
          endDate:
            this.$now().getHours() >= 0 && this.$now().getHours() <= 2
              ? this.$preDate()
              : this.$now.date(),
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        paymentMethod: null,
        extra: null,
        product: null,
        personal: null,
        order: null,
        price: {
          min: null,
          max: null,
        },
        branch: this.$currentUser.branch,
        isNavigatedByQuestion: false,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      if (col === "branch") this.tableOptions[col] = this.$currentUser.branch;
      else this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    getOrderLogs() {
      if (this.$isRegionalCenterBranch()) {
        getOrderLogsForDealer(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            this.orderLogs = res.data.items;
            this.totalDataRow = res.data.totalCount;
            this.totalPriceWithoutPaging = res.data.totalPrice
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hata : " + res.status,
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Satış Kayıtları Yüklenemedi ! ",
          });
        });
      }else{

      
      getOrderLogs(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            this.orderLogs = res.data.items;
            this.totalDataRow = res.data.totalCount;
            this.totalPriceWithoutPaging = res.data.totalPrice
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hata : " + res.status,
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Satış Kayıtları Yüklenemedi ! ",
          });
        });
      }
    },
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.getOrderLogs();
        });
      },
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
  created: function () {
    this.clearFilter();
    if (!this.$isCenterBranch()) {
      if (!this.$isRegionalCenterBranch()) {
        let branchPropIndex = this.filterOptions.indexOf("branch");
      this.filterOptions.splice(branchPropIndex, 1);
      this.filterOptionNames.splice(branchPropIndex, 1);

      delete this.tableOptions["branch"];
      }
      
    }
  },
};
</script>

<style>
.entryDetailRow {
  border-bottom: 0.1rem solid #d3d3d3;
}

.entryDetailPayment {
  justify-content: center;
  align-self: center;
}

#orderLogsTable .con-tablex {
  max-height: calc(100vh - 230px);
  overflow-y: auto;
}
</style>
